// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  Container,
  Tooltip,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import AppConfig from "appConfig";
import { useAuthUser } from "react-auth-kit";

// import Editor from "react-simple-wysiwyg";

function CampaignOrders() {
  const pageTitle = "Campaign Sales";
  usePageTitle(pageTitle);

  const { id } = useParams();
  const navigate = useNavigate();
  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  // const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  let currency = "";
  const [orders, setOrders] = useState([]);
  const [campaign, setCampaign] = useState({});

  const [openDispenseDialog, setOpenDispenseDialog] = useState(false);
  const [order, setOrder] = useState(null);

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(stringtext) {
    console.log(stringtext);
    try {
      await navigator.clipboard.writeText(stringtext);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const tableColumns = [
    { Header: "Order", accessor: "order", align: "center" },
    // { Header: "Campaign", accessor: "campaign", align: "left" },
    { Header: "Amount", accessor: "amount", align: "left" },
    { Header: "Customer", accessor: "customer", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Group", accessor: "agent_group", align: "left" },
    { Header: "Execution Partner", accessor: "aggregator", align: "left" },
    // { Header: "Country", accessor: "country", align: "left" },
    // { Header: "State", accessor: "state", align: "left" },
    // { Header: "City", accessor: "city", align: "left" },
    // { Header: "Tag", accessor: "tag", align: "left" },
    { Header: "Location", accessor: "location", align: "center" },
    { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        // campaign: row.campaign,
        amount: `${currency}${(row.amount / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        customer: row.customer,
        voucher: row.voucher,
        agent: row.agent,
        agent_group: row.agent_group,
        aggregator: row.aggregator,
        country: row.country ? row.country : "--",
        state: row.state ? row.state : "--",
        city: row.city ? row.city : "--",
        tag: row.tag ? row.tag : "--",
        location: (
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://maps.google.com?q=${row.latitude},${row.longitude}`}
          >
            <Icon>location_on</Icon>
          </a>
        ),
        order: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="info"
              iconOnly
              circular
              onClick={() => {
                if (row.successful) {
                  setOrder(row);
                  setOpenDispenseDialog(false);
                  navigate(`/campaigns-orders/${row.reference}`);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                visibility
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/${id}/orders.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            currency = result.data.data.currency;
            setCampaign(result.data.data.campaign);
            // setProductCount(result.data.data.product_count);
            // setItemCount(result.data.data.item_count);
            // setUsedCount(result.data.data.used_count);
            const rows = buildRateRows(result.data.data.orders);
            setOrders(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {order ? (
        <Dialog open={openDispenseDialog} fullWidth maxWidth="sm">
          <DialogContent>
            <Container align="center">
              <MDTypography align="center">
                <MDBox>
                  <MDTypography variant="caption" fontWeight="medium">
                    Order ID
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light">
                    {order.reference} &nbsp;{" "}
                    <MDButton
                      iconOnly
                      onClick={() => {
                        copy(order.reference);
                      }}
                      color="info"
                      variant="outlined"
                      size="small"
                    >
                      <Icon>content_copy</Icon>
                    </MDButton>
                  </MDTypography>
                  {order.items.map((orderItem) => (
                    <MDBox mt={1} align="left">
                      <Divider />
                      <MDTypography variant="h6" fontWeight="light">
                        Product: {orderItem.product}
                      </MDTypography>
                      {typeof orderItem.items !== "undefined" ? (
                        <>
                          {orderItem.objects.map((object) => (
                            <>
                              {object.map((record) => (
                                <MDBox
                                  mt={1}
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <MDBox>
                                    <MDTypography variant="caption" fontWeight="light">
                                      <b>{record.display_name}</b>
                                      <br />
                                      {record.value}
                                    </MDTypography>
                                  </MDBox>
                                  <MDBox>
                                    <MDButton
                                      iconOnly
                                      onClick={() => {
                                        copy(record.value);
                                      }}
                                      color="info"
                                      variant="outlined"
                                      size="small"
                                    >
                                      <Icon>content_copy</Icon>
                                    </MDButton>
                                  </MDBox>
                                </MDBox>
                              ))}
                            </>
                          ))}
                        </>
                      ) : (
                        <MDTypography variant="h6" fontWeight="regular">
                          N/A
                        </MDTypography>
                      )}
                    </MDBox>
                  ))}
                </MDBox>
                <Snackbar
                  autoHideDuration={5000}
                  onClose={() => setOpenSnackBar(false)}
                  open={openCopySnackBar}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert severity="success" sx={{ width: "100%" }}>
                    Copied
                  </Alert>
                </Snackbar>
              </MDTypography>
            </Container>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenDispenseDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Close
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      {/* <Dialog open={openUploadAgentsDialog}>
        <DialogTitle>
          <MDBox>Upload Agents</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={4}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadAgentsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="primary"
            variant="outlined"
            onClick={() => {
              uploadAgents();
            }}
          >
            Upload Agents
          </MDButton>
        </DialogActions>
      </Dialog> */}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox
                        pt={0}
                        px={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDBox>
                          <MDTypography variant="subtitle2" fontWeight="light">
                            Sales
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="medium">
                            {campaign.title}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Tooltip title="Refresh">
                            <MDButton
                              variant="outlined"
                              color="info"
                              iconOnly
                              onClick={() => {
                                setRefreshPage(!refreshPage);
                              }}
                            >
                              <Icon>replay</Icon>
                            </MDButton>
                          </Tooltip>
                          &nbsp;
                          <Tooltip title="Download Sales">
                            <MDButton
                              variant="outlined"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                const downloadUrl = `${AppConfig.api_base_url}campaigns/reports/${campaign.reference}/${accountInfo.user.reference}`;
                                window.open(downloadUrl, "_blank");
                              }}
                            >
                              <Icon>download</Icon>
                            </MDButton>
                          </Tooltip>
                          &nbsp;|&nbsp;
                          <Tooltip title="Campaign Insights">
                            <MDButton
                              variant="outlined"
                              color="warning"
                              iconOnly
                              onClick={() => {
                                navigate(`/campaigns/${campaign.reference}`);
                              }}
                            >
                              <Icon>insights</Icon>
                            </MDButton>
                          </Tooltip>
                          &nbsp;
                          <Tooltip title="Manage Campaign">
                            <MDButton
                              variant="outlined"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                navigate(`/campaigns/${campaign.reference}/settings`);
                              }}
                            >
                              <Icon>settings</Icon>
                            </MDButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: orders }}
                          isSorted
                          entriesPerPage
                          showTotalEntries
                          buttons
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignOrders;
